import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Préférence / favori — cœur duotone.
 * Distinct de FamilyEventIcon (qui a deux cœurs imbriqués pour événement familial).
 */
export const HeartIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Cœur rempli menthe */}
      <path
        d="M12 21S3 14.5 3 8.5a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6-9 12.5-9 12.5z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.6"
      />
      {/* Contour bleu */}
      <path
        d="M12 21S3 14.5 3 8.5a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6-9 12.5-9 12.5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
HeartIcon.displayName = "HeartIcon";
